import React from 'react';
import { Input } from 'reactstrap';
import PaperclipIcon from 'mdi-react/PaperclipIcon';
import EmoticonIcon from 'mdi-react/EmoticonIcon';
import SendIcon from 'mdi-react/SendIcon';





const ChatField = ({ onKeyUp, onClick, t }) => (
  <div className="chat__text-field">
    <form className="chat__form" onSubmit={(e) => { e.preventDefault();}}>
      <Input className="chat__field-input" id="chatField" name="chatField" placeholder={t('chats.typeHere')} 
            onKeyUp={onKeyUp} />
      <div className="chat__field-controls">
        {/* <button
          type="button"
          className="chat__icon-button"
          onClick={(e) => { e.preventDefault(); }}
        >
          <EmoticonIcon />
        </button>
        <button
          type="button"
          className="chat__icon-button"
          onClick={(e) => { e.preventDefault(); }}
        >
          <PaperclipIcon />
        </button> */}
        <button type="button" className="chat__icon-button" onClick={onClick}>
          <SendIcon />
        </button>
      </div>
    </form>
  </div>
);

export default ChatField;
